<template>
  <div class="report" v-on:click="$emit('click')">
    <div class="container">
      <img src="@/assets/images/ic-report-question.svg" class="icon" alt="report">
    </div>
  </div>
</template>

<script>
export default {
  name: 'quiz-report',
};
</script>

<style lang="scss" scoped>
  .report {

    .container {
      max-width: 560px;

      .icon {
        cursor: pointer;
        float: right;
        width: 48px;
        height: 48px;
      }

    }
  }
</style>
